

















































































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import { GetCurrentUserData, PostUserData } from "@/request/account";
import Copy from "@/components/copy.vue";
import Header from "../../components/common-header.vue";
import LeftNav from "../../components/left-nav.vue";
@Component({
  components: {
    Header,
    LeftNav,
    Copy,
  },
})
export default class AccountManage extends Vue {
  private ifCompose: boolean = false;
  private user: any = {};
  private tempUser: any = {};
  /**
   * @description 获取用户信息
   */
  private fetchUserData() {
    GetCurrentUserData(this).then((data: any) => {
      this.user = data;
    });
  }
  /**
   * @description 开始编辑
   */
  private startCompose() {
    this.tempUser = _.cloneDeep(this.user);
    this.ifCompose = true;
  }
  /**
   * @description 取消
   */
  private cancel() {
    this.ifCompose = false;
    this.tempUser = {};
  }
  /**
   * @description 保存
   */
  private save() {
    const params: any = _.cloneDeep(this.tempUser);
    PostUserData(this, params).then((data: any) => {
      this.$message.success("修改成功");
      this.tempUser = {};
      this.ifCompose = false;
      this.fetchUserData();
    });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.fetchUserData();
  }
}
